import { useEffect, useState } from 'react';
import { Modal } from '@/shared/components/ui/Modal';
import { Button } from '@/shared/components/ui/Button';
import { Input } from '@/shared/components/ui/Input';

interface ResetPasswordModalProps {
  open: boolean;
  userName: string;
  loading?: boolean;
  onClose: () => void;
  onSubmit: (password: string) => void;
}

export function ResetPasswordModal({ open, userName, loading, onClose, onSubmit }: ResetPasswordModalProps) {
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (open) setPassword('');
  }, [open]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.length < 6) return;
    onSubmit(password);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Reset Password — ${userName}`}
      size="sm"
      footer={
        <>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button type="submit" form="reset-pwd-form" loading={loading}>
            Reset Password
          </Button>
        </>
      }
    >
      <form id="reset-pwd-form" onSubmit={handleSubmit} className="space-y-3">
        <Input
          label="New Password"
          name="reset-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="At least 6 characters"
          required
        />
      </form>
    </Modal>
  );
}
